export default function Heritage() {
  return (
    <section className="relative py-32 px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/demo/hotel-site/images/heritage.png"
          alt="Hotel Heritage"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/50 to-black/60"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto text-center">
        <div className="max-w-3xl mx-auto text-white">
          <p className="text-sm tracking-widest uppercase mb-6">継承される美学</p>
          <h3 className="text-5xl md:text-6xl font-serif mb-8 leading-tight">
            百年先へ、託す想い
          </h3>
          <p className="text-lg leading-relaxed mb-6 text-white/90">
            日本建築の粋を現代に。館内には人間国宝の作品から新進気鋭のアーティストまで、日本の美意識を伝える300点以上のアートが息づいています。
          </p>
          <p className="text-base leading-relaxed text-white/90">
            建具の木目、壁の左官仕上げ、調度品の佇まい。細部に宿る美こそ、私どもが大切にする「おもてなし」の形です。
          </p>
        </div>
      </div>
    </section>
  );
}